module.exports = __webpack_public_path__ + "static/media/README.2a335055.md";